import React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';

export const CustomSuggestiveSingleSelect = ({
  dataList,
  handleFilterName,
  value,
  label,
  dataItemKey,
  textField,
  classN,
  // Invoked unconditionally by onClose below, so the default has to be callable.
  // ManageSplitGroupModal has three call sites that omit it.
  onCloseEnv = () => {},
  loading = false,
  filterable = true,
  isFromLingLeg = false,
  onOpen,
  renderItem,
  opened,
}) => {
  const [ filter, setFilter ] = React.useState(null);

  const handleChange = (event) => {
    if(event?.target?.value?.isDisable){
      return;
    }
    handleFilterName(event);
  };

  const handleFilterChange = (event) => {
    setFilter(event.filter);
  };

  const onClose = (e) => {
    if (e.nativeEvent.code === 'Enter') {
      handleFilterName(e);
    }
    onCloseEnv(e);
    setFilter({ value: '' });
  };

  const filteredData = !filter ? dataList : dataList?.filter((item) => item[textField]?.toLowerCase()?.includes(filter?.value?.toLowerCase()));

  return (
    <div>
      <DropDownList
        data={filteredData}
        value={value}
        onChange={handleChange}
        onFilterChange={handleFilterChange}
        label={label}
        className={'custom-input ' + classN}
        dataItemKey={dataItemKey}
        textField={textField}
        filterable={filterable}
        filterPlaceholder="Search..."
        filter={filter?.value}
        onClose={onClose}
        onOpen={onOpen}
        itemRender={renderItem || ((li, item) => itemRender(li, item, isFromLingLeg))}
        opened={opened}
        loading={loading}
      />
    </div>
  );
};

const itemRender = (li, itemProps, isFromLingLeg) => {
  let itemChildren = null;
  if(isFromLingLeg){
    itemChildren = (
      <span className="custom-dropdown-item" style={{ color: itemProps?.dataItem?.isDisable ? '#808080' : '#00106e' }}>
        {itemProps?.dataItem?.ListName}
      </span>
    );
  }else{
    itemChildren = (
      <span style={{ color: '#00106e' }}>
        {li?.props?.children}
      </span>
    );
  }
  return React.cloneElement(li, li.props, itemChildren);
};
